import { useMutation } from "react-query";
import getDocumentSignatureStatusUpdate from "../services/getDocumentSignatureStatusUpdate";

function useGetDocSignatureStatusUpdate() {
  return useMutation(
    ["document-signature-update"],
    getDocumentSignatureStatusUpdate
  );
}

export default useGetDocSignatureStatusUpdate;
